import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Grid,
  Dialog,
  Skeleton
} from '@mui/material';
import { useNavigate } from 'react-router';
import CustomDataGrid from '../../../../common/components/customized/customdatagrid/CustomDataGrid';
import CustomDialog from '../../../../common/components/customdialog/CustomDialog';
import { useAppDispatch, useAppSelector } from '../../../../app/redux/hooks';
import {
  getAllTrips,
  getAllOptimizedRoute,
  clearTrips,
  getTripsandOrderCount,
  deleteKhubTrip
} from '../../redux/reducer/deliveryTrackingSlices/khubtripsSlice';
import constant from '../../../../utils/constants';
import {
  capitalizeFirstLetter,
  epochToDate,
  tripOrOrderStatus
} from '../../../../utils/commonFunctions';
import { updatePolyline } from '../../../../common/redux/reducer/commonSlices/polylineSlice';
import {
  updateCenter,
  updateZoom
} from '../../../../common/redux/reducer/commonSlices/mapSlice';
import { updateWaypoints } from '../../../yaantrac/redux/reducer/yaantracSlices/reportSlice';
import CustomButton from '../../../../common/components/buttons/CustomButton';
import CustomCountCard from '../customcountcard/CustomCountCard';
import { Icon } from '@iconify/react';
import './Trips.scss';
import {
  clearOrderByStatus,
  getOrderByStatus,
  getTripsDropdown,
  reassignTripOrders
} from '../../redux/reducer/deliveryTrackingSlices/deliverytripsSlice';
import RescheduleOrder from './rescheduleorder/RescheduleOrder';
import CustomTab from '../../../../common/components/tab/CustomTab';
import CustomSwitch from '../../../../common/components/switch/CustomSwitch';
import AddDeliveryTrips from './adddeliverytrip/AddDeliveryTrips';
import CustomSelect from '../../../../common/components/customized/customselect/CustomSelect';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { updateToast } from '../../../../common/redux/reducer/commonSlices/toastSlice';
import CustomDeletePopup from '../../../../common/components/customdelete/CustomDeletePopup';
import InfiniteScroll from '../../../../common/components/infinitescroll/InfiniteScroll';
import { debounce } from 'lodash';
import CustomBreadcrumbs from '../../../../common/components/custombreadcrumbs/CustomBreadcrumbs';
import Orders from './orders/Orders';

interface Row {
  id: number;
  tripID: number;
  vehicleNumber: string;
  driverName: string;
  startTime: string;
  startDate: string;
  endTime: string;
  endDate: string;
  tripTotalDistance_KM: number;
  tripTotalDuration_HRS_MIN: string;
  orderTotal: number;
  status: string;
}

interface Column {
  field: string;
  headerName: string;
  minWidth: number;
  flex: number;
  renderCell?: (params: { row: Row }) => any;
  textAlign?: string;
}

interface TripsProps {
  onScroll: (data: any) => void;
  setApi: React.Dispatch<
    React.SetStateAction<{ handlePagination: Function; fetchedData: any; count: number }>
  >;
  clearState: () => void;
}

function DeliveryTrips({ onScroll, setApi, clearState }: TripsProps) {
  const [view, setView] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [orderStatus, setOrderStatus] = useState<string>('overall');
  const [tripDetails, setTripDetails] = useState<[] | null>(null);
  const [isDialog, setIsDialog] = useState('');
  const [tabValue, setTabValue] = useState(1);
  const [rescheduledOrderDetails, setRescheduleOrderDetails] = useState<any>([]);
  const [rescheduleOrders, setRescheduleOrders] = useState(false);
  const [tripOrders, setTripOrders] = useState(false);
  const [tripID, setTripID] = useState('');
  const openMenu = Boolean(anchorEl);
  // const [switchType, setSwitchType] = useState('Trips');
  const [orderType, setOrderType] = useState('RESCHEDULED');
  const [firstLoad, setFirstLoad] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [pageNo, setPageNo] = useState(1);
  const [filter, setFilter] = useState('');
  const tabLists =
    // switchType === 'Trips'
    // true
    // ? //  ['Expired', 'Scheduled', 'In-transit', 'Completed']
    ['Expired', 'Scheduled', 'Completed'];
  // : [
  //     'Rescheduled',
  //     'Not Delivered',
  //     'Cancelled',
  //     'In-transit',
  //     'Pending',
  //     'Completed'
  //   ];

  const abortController = useRef<AbortController | null>(null);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    data: tripsDatas,
    isLoading,
    count: tripCount
  } = useAppSelector(state => state.khubtrips);
  const {
    data: orderByStatus,
    isLoading: getOrdersLoading,
    count
  } = useAppSelector((state: any) => state.orderByStatus);
  const { Waypoints } = useAppSelector(state => state.reportDialog);
  const {
    data,
    path,
    isLoading: routeLoading
  } = useAppSelector((state: any) => state.khubtripsroute);

  const { isLoading: tripDeleteLoading } = useAppSelector(state => state.tripKhubDelete);
  const { isLoading: tripsDropdownLoading, tripList } = useAppSelector(
    (state: any) => state.orderrescheduleTrips
  );
  const { isLoading: orderAssignLoading } = useAppSelector(state => state.reassignOrders);
  const handleClose = () => setAnchorEl(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterChange = debounce((e: string) => {
    setFilter(e);
    let filteredData = orderByStatus
      ?.filter((item: any) => {
        let orderId = item?.assignedOrderId?.toLowerCase();
        return orderId?.includes(e.toLowerCase());
      })
      .map((value: any) => ({
        ...value,
        selected: false
      }));
    setRescheduleOrderDetails(filteredData);
  }, 200);

  const tripsDropdownOptions =
    tripList?.length > 0
      ? tripList?.map((item: string, index: number) => ({
          id: String(item),
          label: String(item)
        }))
      : [];

  const columns: Column[] = [
    {
      field: 'tripID',
      headerName: 'Dispatch ID',
      minWidth: 120,
      flex: 1
    },
    {
      field: 'vehicleNumber',
      headerName: 'Vehicle No.',
      minWidth: 150,
      flex: 1,
      renderCell: ({ row }) => row?.vehicleNumber?.toUpperCase()
    },
    {
      field: 'load',
      headerName: 'Load',
      minWidth: 150,
      flex: 1,
      renderCell: ({ row }) => row?.vehicleNumber?.toUpperCase()
    },

    {
      field: 'driverNames',
      headerName: 'Driver Name',
      minWidth: 150,
      flex: 1,
      renderCell: ({ row }) => capitalizeFirstLetter(row?.driverName)
    },
    {
      field: 'startDate',
      headerName: 'Start Date & Time',
      minWidth: 220,
      flex: 1
    },

    {
      field: 'endDate',
      headerName: 'End Date & Time',
      minWidth: 220,
      flex: 1
    },
    {
      field: 'tripTotalDistance_KM',
      headerName: 'Dispatch Distance(Km)',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'tripTotalDuration_HRS_MIN',
      headerName: 'Dispatch Duration',
      minWidth: 160,
      flex: 1
    },
    {
      field: 'totalDeliverables',
      headerName: 'Total Orders',
      minWidth: 140,
      flex: 1
    },
    {
      field: 'completedDeliverables',
      headerName: 'Completed Orders',
      minWidth: 160,
      flex: 1
    },
    {
      field: 'status',
      headerName: 'Dispatch Status',
      minWidth: 150,
      flex: 1,
      renderCell: ({ row }: any) => tripOrOrderStatus(row?.status)
    },
    {
      field: 'actions',
      headerName: 'Action',
      minWidth: 100,
      flex: 1,
      renderCell: params => (
        <Box className='actions'>
          <Tooltip title='Menu' placement='right' arrow>
            <IconButton
              id='basic-button'
              aria-controls='true'
              onClick={(event: any) => {
                handleClick(event);
                setSelectedRow(params.row);
              }}
            >
              <Icon icon='eva:menu-2-outline' className='menu-bg' />
            </IconButton>
          </Tooltip>
          <Menu
            id='basic-menu'
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            <MenuItem className='menu-dialog' onClick={() => handleViewOrderDetails()}>
              <Icon icon='lets-icons:view-fill' className='menu-icon view' />
              {constant.View}
            </MenuItem>
            <MenuItem className='menu-dialog' onClick={() => handleViewTrip()}>
              <Icon icon='bx:trip' className='menu-icon view' /> {constant.Map}
            </MenuItem>

            {(tabValue === 0 || tabValue === 1) && (
              <>
                <MenuItem
                  className='menu-dialog'
                  onClick={e => {
                    setOpen(true);
                    handleClose();
                  }}
                >
                  <Icon icon='ic:baseline-edit' className='menu-icon update' />
                  {constant.Update}
                </MenuItem>
                <MenuItem
                  className='menu-dialog'
                  onClick={() => {
                    setIsDialog('Delete');
                    handleMenuClose();
                  }}
                >
                  <Icon
                    icon='ic:outline-delete'
                    className='menu-icon'
                    style={{ color: '#FF4343' }}
                  />
                  {constant.Delete}
                </MenuItem>
              </>
            )}
          </Menu>
        </Box>
      )
    }
  ];

  const handleDeleteTrip = async () => {
    if (selectedRow) {
      const payload = {
        selectedRow: selectedRow,
        duration: 'All',
        status: capitalizeFirstLetter(orderStatus)
      };
      await dispatch(deleteKhubTrip(payload));
      setTabValue(1);
      setIsDialog('');
    }
  };

  const schema = yup.object().shape({
    triplist: yup.string().required('Dispatch ID is required'),
    search: yup.string().required('Filter is required')
  });

  const { control, getValues, setValue } = useForm({ resolver: yupResolver(schema) });

  const handleAddorUpadteTrip = () => {
    setSelectedRow(null);
    setOpen(true);
  };

  const handleViewOpen = (id: string) => {
    setOrderStatus(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // for view details
  const handleViewTrip = async () => {
    await dispatch(getAllOptimizedRoute(selectedRow?.tripID));
    setAnchorEl(null);
    setView(true);
  };

  const handleViewTripClose = () => setView(false);

  //function to handle trip status
  const handleTripChange = async (e: React.SyntheticEvent, newValue: number) => {
    if (abortController.current) {
      await abortController.current.abort();
    }
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    setTabValue(newValue);
    dispatch(clearTrips());
    dispatch(clearOrderByStatus());
    switch (newValue) {
      case 0:
        await dispatch(
          getAllTrips({ status: 'Expired', pageno: 1, pagesize: 5, signal: signal })
        );
        break;
      case 1:
        await dispatch(
          getAllTrips({ status: 'Scheduled', pageno: 1, pagesize: 5, signal: signal })
        );
        break;
      case 2:
        await dispatch(
          getAllTrips({ status: 'In-transit', pageno: 1, pagesize: 5, signal: signal })
        );
        break;
      case 3:
        await dispatch(
          getAllTrips({ status: 'Completed', pageno: 1, pagesize: 5, signal: signal })
        );
        break;
      default:
        break;
    }
  };

  // // function to handle orders change
  // const handleOrdersChange = async (e: React.SyntheticEvent, newValue: number) => {
  //   setTabValue(newValue);
  //   setValue('triplist', '');
  //   setFirstLoad(true);
  //   clearState();
  //   dispatch(clearTrips());
  //   setRescheduleOrderDetails([]);

  //   if (abortController.current) {
  //     await abortController.current.abort();
  //   }
  //   abortController.current = new AbortController();
  //   const { signal } = abortController.current;
  //   switch (newValue) {
  //     case 0:
  //       setOrderType('RESCHEDULED');
  //       await dispatch(
  //         getOrderByStatus({
  //           status: 'RESCHEDULED',
  //           pageno: 1,
  //           pagesize: 8,
  //           signal: signal
  //         })
  //       );
  //       break;
  //     case 1:
  //       setOrderType('NOT_DELIVERED');
  //       await dispatch(
  //         getOrderByStatus({
  //           status: 'NOT_DELIVERED',
  //           pageno: 1,
  //           pagesize: 8,
  //           signal: signal
  //         })
  //       );
  //       break;
  //     case 2:
  //       setOrderType('CANCELLED');
  //       await dispatch(
  //         getOrderByStatus({
  //           status: 'CANCELLED',
  //           pageno: 1,
  //           pagesize: 8,
  //           signal: signal
  //         })
  //       );
  //       break;
  //     case 3:
  //       setOrderType('IN_TRANSIT');
  //       await dispatch(
  //         getOrderByStatus({
  //           status: 'IN_TRANSIT',
  //           pageno: 1,
  //           pagesize: 8,
  //           signal: signal
  //         })
  //       );
  //       break;
  //     case 4:
  //       setOrderType('PENDING');
  //       await dispatch(
  //         getOrderByStatus({ status: 'PENDING', pageno: 1, pagesize: 8, signal: signal })
  //       );
  //       break;
  //     case 5:
  //       setOrderType('STOP_COMPLETE');
  //       await dispatch(
  //         getOrderByStatus({
  //           status: 'STOP_COMPLETE',
  //           pageno: 1,
  //           pagesize: 8,
  //           signal: signal
  //         })
  //       );
  //       break;
  //     default:
  //       break;
  //   }
  //   setFirstLoad(false);
  // };

  //function for infinite scroll pagination
  const handleInfinitePagination = async (pageNo: number) => {
    await dispatch(getOrderByStatus({ status: orderType, pageno: pageNo, pagesize: 8 }));
  };

  //function to assign vehicle
  const handleAssign = () => {
    if (!getValues('triplist')) {
      dispatch(
        updateToast({
          show: true,
          message: 'Select Dispatch ID',
          severity: 'error'
        })
      );
    } else if (!rescheduledOrderDetails?.some((item: any) => item.selected)) {
      dispatch(
        updateToast({
          show: true,
          message: 'No orders selected',
          severity: 'error'
        })
      );
    } else {
      setRescheduleOrders(true);
    }
  };

  //function to close assign popup
  const handleAssignPopup = () => {
    setRescheduleOrders(false);
  };

  //function to handle reassign orders
  const handleAssignOrders = async () => {
    let selectedOrders = rescheduledOrderDetails
      ?.filter((item: any) => item?.selected)
      .map((value: any) => value?.assignedOrderId);
    let payload = {
      tripId: Number(tripID),
      assignedOrderId: selectedOrders
    };
    await dispatch(reassignTripOrders({ payload, orderType: orderType }));
    setRescheduleOrders(false);
  };

  //function for trips and orders mode change
  // const onSwitchChange = async (option: string) => {
  //   setRescheduleOrderDetails([]);
  //   setSwitchType(option);
  //   if (option === 'Orders') {
  //     setTabValue(0);
  //     await dispatch(getOrderByStatus({ status: 'RESCHEDULED', pageno: 1, pagesize: 8 }));
  //     await dispatch(getTripsDropdown());
  //   } else {
  //     setTabValue(1);
  //     await dispatch(getAllTrips({ status: 'Scheduled', pageno: 1, pagesize: 5 }));
  //   }
  // };

  const handleViewOrderDetails = () => {
    setAnchorEl(null);
    setTripOrders(true);
  };

  //  function to handle pagination model change
  const handlePaginationModelChange = async (newPaginationModel: any) => {
    const { pageSize: newPageSize, page: newPageNo } = newPaginationModel;
    setPageSize(newPageSize);
    setPageNo(newPageNo + 1);
    switch (tabValue) {
      case 0:
        await dispatch(
          getAllTrips({ status: 'Expired', pageno: newPageNo + 1, pagesize: newPageSize })
        );
        break;
      case 1:
        await dispatch(
          getAllTrips({
            status: 'Scheduled',
            pageno: newPageNo + 1,
            pagesize: newPageSize
          })
        );
        break;
      case 2:
        await dispatch(
          getAllTrips({
            status: 'In-transit',
            pageno: newPageNo + 1,
            pagesize: newPageSize
          })
        );
        break;
      case 3:
        await dispatch(
          getAllTrips({
            status: 'Completed',
            pageno: newPageNo + 1,
            pagesize: newPageSize
          })
        );
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setApi({
      handlePagination: handleInfinitePagination,
      fetchedData: rescheduledOrderDetails,
      count: count
    });
  }, [orderType, count, rescheduledOrderDetails]);

  const CardLoader = () => {
    return (
      <Grid container className='ordercard-loader' spacing={2}>
        {[...Array(8)].map((_, index) => (
          <Grid item lg={3} md={4} sm={12} xs={12}>
            <Box className='ordercard-layout'>
              <Box>
                <Skeleton
                  className='image-skeleton'
                  variant='rectangular'
                  animation='pulse'
                />
              </Box>
              <Box className='ordercard-content'>
                <Skeleton
                  variant='text'
                  className='text-loader'
                  animation='pulse'
                  sx={{ fontSize: '2rem' }}
                  width={'60%'}
                />
                <Skeleton
                  variant='text'
                  className='text-loader'
                  animation='pulse'
                  sx={{ fontSize: '2rem' }}
                  width={'90%'}
                  height={30}
                />
                <Skeleton
                  variant='text'
                  className='text-loader'
                  animation='pulse'
                  sx={{ fontSize: '1.2rem', borderRadius: '15px' }}
                  width={'50%'}
                  height={40}
                />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    );
  };

  useEffect(() => {
    if (orderByStatus?.length > 0) {
      const rescheduledOrdersData =
        orderByStatus?.map((item: any) => ({
          ...item,
          selected: false
        })) ?? [];
      setRescheduleOrderDetails([...rescheduledOrderDetails, ...rescheduledOrdersData]);
    }
  }, [orderByStatus]);

  useEffect(() => {
    dispatch(getAllTrips({ status: 'Scheduled', pageno: 1, pagesize: 5 }));
    return () => {
      dispatch(clearTrips());
    };
  }, []);

  useEffect(() => {
    if (tripsDatas) {
      let data: any = tripsDatas?.map((item: any, index: number) => ({
        ...item,
        id: index + 1,
        startDate: epochToDate(item?.startTimestamp),
        endDate: epochToDate(item?.endTimestamp)
      }));
      setTripDetails(data);
    } else {
      setTripDetails([]);
    }
  }, [tripsDatas]);

  useEffect(() => {
    if (path?.length > 0) {
      dispatch(updatePolyline(path));
      const [planned, actual] = path;
      dispatch(
        updateZoom(actual.path ? [...planned.path, ...actual.path] : [...planned.path])
      );
      dispatch(
        updateCenter(actual.path ? [...planned.path, ...actual.path] : [...planned.path])
      );
    }
  }, [path]);

  useEffect(() => {
    const waypoints =
      data?.optimizedDeliverablesInfoList?.length > 0
        ? data?.optimizedDeliverablesInfoList
            ?.filter((item: any) => item.coordinateType !== 'TRIP_SOURCE')
            .map((item: any, index: number) => ({
              id: `waypoint${index + 1}`,
              name: 'waypoints',
              type: 'deliverytracking',
              lat: item?.coordinates?.lat,
              lng: item?.coordinates?.lng,
              status: item?.status,
              color:
                item?.status === 'IN_TRANSIT'
                  ? '#fca100'
                  : item?.coordinateType === 'DIRECT_SALES'
                  ? '#fca100'
                  : item?.coordinateType === 'ORDER_DELIVERY'
                  ? '#1e4c8a'
                  : item?.coordinateType === 'ADHOC'
                  ? 'red'
                  : '#ed0f0f',
              info:
                item?.coordinateType === 'DIRECT_SALES'
                  ? {
                      Mylocation: `Direct Sales ID-${item?.id}`,
                      'Customer Name': item?.customerName,
                      'Order Status': item?.status,
                      'Contact No': item?.contactNumber
                    }
                  : item?.coordinateType === 'ORDER_DELIVERY'
                  ? {
                      Mylocation: `Order ID-${item?.id}`,
                      'Order Status': item?.status,
                      'No of Boxes': item?.totalBoxesCount,
                      'Scanned Boxes': item?.successfulScanCount,
                      'Contact No': item?.contactNumber
                    }
                  : {}
            }))
        : [];

    const adHocStatus = data?.adhocStopResponses?.map((item: any, index: number) => ({
      id: `adhoc${index + 1}}`,
      name: 'waypoints',
      type: 'deliverytracking',
      lat: item?.coordinates?.lat,
      color: '#be00cd',
      lng: item?.coordinates?.lng,
      status: item?.status,
      info: {
        Mylocation: `ADHOC ${index + 1}`
      }
    }));
    let source = data?.optimizedDeliverablesInfoList
      ? data?.optimizedDeliverablesInfoList
          ?.filter((item: any) => item?.coordinateType === 'TRIP_SOURCE')
          .map((item: any) => {
            return {
              id: 'source',
              lat: item?.coordinates?.lat,
              lng: item?.coordinates?.lng,
              type: 'deliverytracking',
              color: '#05850f',
              info: {
                Mylocation: 'Source',
                Status: item?.status
              }
            };
          })
      : [];

    let locations = [...source, ...waypoints, ...(adHocStatus ? adHocStatus : [])];
    dispatch(updateWaypoints(locations));
  }, [data]);

  useEffect(() => {
    const id = setInterval(() => {
      if (!routeLoading && view) {
        dispatch(getAllOptimizedRoute(selectedRow?.tripID));
      }
    }, 7000);

    return () => {
      clearInterval(id);
    };
  }, [data, !routeLoading, selectedRow, view]);

  return (
    <Box className='tracking-container'>
      {/* {!tripOrders && (
        <Box className='trips-switch'>
          <CustomSwitch option1='Trips' option2='Loads' onChange={onSwitchChange} />
        </Box>
      )} */}

      {/* {switchType === 'Trips' && ( */}
      <CustomBreadcrumbs
        itemOne={'Dispatch'}
        itemTwo={'Orders'}
        itemTwoState={tripOrders}
        setView={setTripOrders}
        handleItemOneClick={() => {
          setTripOrders(false);
        }}
      />
      {/* )} */}

      {!tripOrders && (
        <Box className='add-trip-btn'>
          <CustomTab
            value={tabValue}
            tabList={tabLists}
            // onChange={switchType === 'Trips' ? handleTripChange : handleOrdersChange}
            onChange={handleTripChange}
          />
          {/* {switchType === 'Trips' ? ( */}
          <CustomButton
            className='saveChanges'
            category='Add Dispatch'
            onClick={handleAddorUpadteTrip}
          />
          {/* ) 
          : (
            <CustomButton
              className='saveChanges'
              category='Add Load'
              onClick={handleAddorUpadteTrip}
            />
          )} */}
          {/* {switchType === 'load' && (
            <Box sx={{ display: 'flex', gap: '10px' }}>
              {switchType === 'load' &&
                ['NOT_DELIVERED', 'RESCHEDULED'].includes(orderType) &&
                rescheduledOrderDetails?.length > 0 && (
                  <CustomSelect
                    options={tripsDropdownOptions}
                    id='trip-dropdown'
                    className='trips-dropdown'
                    name='triplist'
                    control={control}
                    placeholder='Select TripID'
                    onChanges={(
                      e: React.SyntheticEvent,
                      newValue: { id: string; label: string }
                    ) => {
                      setTripID(newValue?.id);
                    }}
                  />
                )}
            </Box>
          )} */}
        </Box>
      )}

      {
        !tripOrders && (
          // (switchType === 'Trips' ? (
          <CustomDataGrid
            rows={tripDetails?.length ? tripDetails : []}
            rowCount={tripCount}
            columns={columns}
            loading={isLoading}
            onPaginationModelChange={handlePaginationModelChange}
            pageNo={pageNo}
            pageSize={pageSize}
            type='report'
            paginationModel={{
              page: pageNo ? pageNo - 1 : 0,
              pageSize: pageSize ? pageSize : 5
            }}
          />
        )
        // )
        // : switchType === 'load' && getOrdersLoading && firstLoad ? (
        //   <CardLoader />
        // ) : (
        //   <RescheduleOrder
        //     orders={rescheduledOrderDetails}
        //     currentTrip={selectedRow}
        //     onScroll={onScroll}
        //     handleAssign={handleAssign}
        //     orderType={orderType}
        //     tripID={tripID}
        //     setOrders={setRescheduleOrderDetails}
        //   />
        // ))
      }

      {isDialog === 'Delete' && (
        <Dialog open={isDialog === 'Delete'}>
          <Box
            sx={{
              textAlign: 'center',
              padding: '5%',
              minWidth: '350px'
            }}
          >
            <Typography>{constant.DeleteTrip}</Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '5%',
                justifyContent: 'center'
              }}
            >
              <Box sx={{ marginRight: '12px' }}>
                <CustomButton
                  className='saveChanges'
                  category='Yes'
                  loading={tripDeleteLoading}
                  onClick={() => {
                    handleDeleteTrip();
                  }}
                />
              </Box>
              <CustomButton
                className='cancel'
                category='No'
                onClick={() => setIsDialog('')}
              />
            </Box>
          </Box>
        </Dialog>
      )}

      {/* {open && (
        <AddDeliveryTrips
          isOpen={open}
          setTabValue={setTabValue}
          setIsOpen={setOpen}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      )} */}
      {open && (
        <AddDeliveryTrips
          setIsOpen={setOpen}
          isOpen={open}
          data={[]}
          setTab={setTabValue}
          setChildState={() => {}}
          children={<Box></Box>}
          setTripType={() => {}}
          row={[]}
          setPageNo={setPageNo}
          setPageSize={setPageSize}
          setUpdateData={[]}
        />
      )}

      {view && (
        <CustomDialog
          isShowDelivery={true}
          isShowPolyline={true}
          view={view}
          handleViewClose={handleViewTripClose}
          locations={Waypoints}
        />
      )}
      {rescheduleOrders && (
        <CustomDeletePopup
          open={rescheduleOrders}
          handleClose={handleAssignPopup}
          handleDelete={handleAssignOrders}
          setOpen={setRescheduleOrders}
          message={`Are  you  sure want to reassign orders for Dispatch ID : ${tripID} ?`}
          isLoading={orderAssignLoading}
        />
      )}
      {tripOrders && <Orders tripId={selectedRow?.tripID} />}
    </Box>
  );
}

export default InfiniteScroll(DeliveryTrips);
